import { useContext } from 'react';

import { AuthContext, type AuthContextValue } from '@/app/auth-context';

/**
 * The signed-in user, their permissions and their branch scope.
 *
 * Throws rather than returning a null-ish default when used outside
 * `AuthProvider`: a component that silently believes nobody is signed in would
 * render an empty screen and look like a data problem, whereas a thrown error
 * points straight at the missing provider.
 */
export const useAuth = (): AuthContextValue => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used inside <AuthProvider>');
  }
  return context;
};

export default useAuth;
